/* =========================================================================
   Vehicle Selector — tabbed UI (additive enhancement)
   -------------------------------------------------------------------------
   Reshapes the theme's <vehicle-selector> accordion into a tabbed UI with
   make icons + auto-submit. Everything is gated behind a .mesh-ready class
   and .mesh-* elements this script creates, so when the switch is OFF the
   script returns immediately and the ORIGINAL selector renders unchanged.

   WHICH SELECTOR SHOWS:
     window.VS_MESH_ENABLED   (set in theme.liquid from the Theme Customizer
                               checkbox "Use new tabbed vehicle selector")
     ?vs=mesh  / ?vs=classic  (on any URL) ...... per-load override (for QA;
                               always wins over the checkbox)

   TAB UNDERLINE STYLE:
     window.VS_MESH_UNDERLINE (set in theme.liquid from the Theme Customizer
                               select "Tab underline style"):
       'tab'      ... red line sits under the active tab only (default)
       'progress' ... red line fills from the left edge through the active
                      tab — a progress bar across the six steps
     ?vsbar=progress / ?vsbar=tab ... per-load override; wins over the setting
   ========================================================================= */
(function () {
  'use strict';

  /* ---- Switches --------------------------------------------------------- */
  function meshOn() {
    var p = null;
    try { p = new URL(location.href).searchParams.get('vs'); } catch (e) {}
    if (p) {
      p = p.toLowerCase();
      if (p === 'mesh' || p === 'new')    { return true; }
      if (p === 'classic' || p === 'old') { return false; }
    }
    return window.VS_MESH_ENABLED === true;
  }
  if (!meshOn()) { return; }   // classic selector — leave the page untouched

  function barMode() {
    var p = null;
    try { p = new URL(location.href).searchParams.get('vsbar'); } catch (e) {}
    if (p) {
      p = p.toLowerCase();
      if (p === 'progress' || p === 'bar') { return 'progress'; }
      if (p === 'tab' || p === 'active')   { return 'tab'; }
    }
    return window.VS_MESH_UNDERLINE === 'progress' ? 'progress' : 'tab';
  }

  /* ---- Selectors & helpers --------------------------------------------- */
  var WRAP = '.select-wrapper.js-vehicle-selector-wrapper';
  var OPT  = '.list-values button, .vehicle-value-item';

  function panelOf(w) { return w.querySelector('.toggle-panel'); }
  function optCount(w) { var p = panelOf(w); return p ? p.querySelectorAll(OPT).length : 0; }
  function labelFor(w, i) {
    var t = w.querySelector('.toggle-trigger');
    var x = t ? (t.textContent || '').trim() : '';
    x = x.replace(/^.*?\bSelect\s+/i, '').trim();
    return x || ('Step ' + (i + 1));
  }
  function injectIcons(wrap, pattern) {
    var opts = wrap.querySelectorAll('.list-values button[data-handle], .list-values .vehicle-value-item[data-handle]');
    for (var i = 0; i < opts.length; i++) {
      var b = opts[i];
      if (b.querySelector('.mesh-make-icon')) { continue; }
      var handle = b.getAttribute('data-handle');
      if (!handle) { continue; }
      var img = document.createElement('img');
      img.className = 'mesh-make-icon';
      img.alt = '';
      img.src = pattern.replace('{handle}', handle);
      img.onerror = function () { this.style.display = 'none'; if (this.parentNode) { this.parentNode.classList.remove('mesh-has-icon'); } };
      b.classList.add('mesh-has-icon');
      b.insertBefore(img, b.firstChild);
    }
  }

  /* ---- Build the tabbed UI for one .vehicle-step-select ----------------- */
  function build(ss) {
    if (!ss || ss.querySelector('.mesh-tabs')) { return; }
    var wraps = [].slice.call(ss.querySelectorAll(WRAP));
    if (wraps.length < 2) { return; }
    var vsEl = ss.closest ? ss.closest('vehicle-selector') : null;

    var tabs = document.createElement('div'); tabs.className = 'mesh-tabs';
    var track = document.createElement('div'); track.className = 'mesh-tabs__track';
    tabs.appendChild(track);
    var prog = document.createElement('span'); prog.className = 'mesh-progress';
    tabs.appendChild(prog);
    ss.insertBefore(tabs, ss.firstChild);

    function sync() {
      var act = -1;
      for (var i = 0; i < wraps.length; i++) { var p = panelOf(wraps[i]); if (p && p.classList.contains('active')) { act = i; } }
      var T = track.querySelectorAll('.mesh-tab');
      for (var j = 0; j < T.length; j++) { if (j === act) { T[j].classList.add('mesh-tab--active'); } else { T[j].classList.remove('mesh-tab--active'); } }
      if (act >= 0 && T[act]) {
        var r = T[act].getBoundingClientRect(), tr = track.getBoundingClientRect();
        prog.style.opacity = '1';
        if (barMode() === 'progress') {
          prog.style.width = (r.right - tr.left) + 'px';
          prog.style.transform = 'translateX(0px)';
        } else {
          prog.style.width = r.width + 'px';
          prog.style.transform = 'translateX(' + (r.left - tr.left) + 'px)';
        }
      } else { prog.style.opacity = '0'; }
    }
    function showTab(i) {
      for (var k = 0; k < wraps.length; k++) { var p = panelOf(wraps[k]); if (p) { if (k === i) { p.classList.add('active'); } else { p.classList.remove('active'); } } }
      sync();
    }
    function doSubmit() { var btn = (vsEl || ss).querySelector('.js-vehicle-submit'); if (btn) { btn.click(); } }

    wraps.forEach(function (w, i) {
      var tab = document.createElement('button');
      tab.type = 'button'; tab.className = 'mesh-tab'; tab.setAttribute('data-idx', i);
      var field = labelFor(w, i);
      tab.setAttribute('data-field', field); tab.textContent = field;
      tab.addEventListener('click', function () { showTab(i); });
      track.appendChild(tab);
    });

    ss.addEventListener('click', function (e) {
      var opt = e.target.closest(OPT);
      if (!opt) { return; }
      var wrap = opt.closest(WRAP);
      var idx = wraps.indexOf(wrap);
      if (idx < 0) { return; }
      var T = track.querySelectorAll('.mesh-tab');
      var value = (opt.textContent || '').trim();
      if (T[idx]) { T[idx].textContent = value; T[idx].title = value; }
      for (var n = idx + 1; n < T.length; n++) { T[n].textContent = T[n].getAttribute('data-field'); T[n].removeAttribute('title'); }
      if (idx === wraps.length - 1) {
        var t2 = 10;
        (function trySubmit() {
          var lt = wraps[idx].querySelector('.toggle-trigger');
          var done = lt && (lt.textContent || '').replace(/Select.*/i, '').trim().length > 0;
          if (done) { doSubmit(); }
          else if (t2-- > 0) { setTimeout(trySubmit, 150); }
          else { doSubmit(); }
        })();
        return;
      }
      var tries = 8;
      (function advance() {
        var nx = idx + 1;
        if (nx < wraps.length && optCount(wraps[nx]) > 0) { showTab(nx); }
        else if (nx < wraps.length && tries-- > 0) { setTimeout(advance, 250); }
        else { showTab(idx); }
      })();
    }, false);

    window.addEventListener('resize', sync);

    /* Footer text block (from <template id="vehicle-selector-foot">) */
    var sc = (ss.closest && ss.closest('.section-content')) || ss.parentElement;
    var footSrc = document.getElementById('vehicle-selector-foot');
    if (sc && footSrc && !sc.querySelector('.mesh-foot')) {
      var foot = document.createElement('div'); foot.className = 'mesh-foot';
      if (footSrc.content) { foot.appendChild(footSrc.content.cloneNode(true)); }
      else { foot.innerHTML = footSrc.innerHTML; }
      sc.appendChild(foot);
    }

    /* Make icons (src pattern from data-icon-pattern on <vehicle-selector>) */
    var pattern = vsEl && vsEl.getAttribute('data-icon-pattern');
    if (pattern && wraps[0]) {
      var tries2 = 8;
      (function tryIcons() {
        if (optCount(wraps[0]) > 0) { injectIcons(wraps[0], pattern); }
        else if (tries2-- > 0) { setTimeout(tryIcons, 200); }
      })();
    }

    if (vsEl) { vsEl.classList.add('mesh-ready'); }
    showTab(0);
  }

  function scan() {
    var list = document.querySelectorAll('vehicle-selector .vehicle-step-select');
    for (var i = 0; i < list.length; i++) { build(list[i]); }
  }

  var pending = false;
  function schedule() { if (pending) { return; } pending = true; setTimeout(function () { pending = false; scan(); }, 80); }
  if (window.MutationObserver) { new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); }
  else { scan(); }
})();